import { Api } from './Api'

const adminsPathTo = {
  listProvidersAccount: () => {
    return Api.request({
      url: '/admins/list_providers_account.json',
      method: 'get'
    })
  },
  access_account: (params) => {
    return Api.request({
      url: '/admins/access_account.json',
      method: 'put',
      params
    })
  },
  clear_access_account: () => {
    return Api.request({
      url: '/admins/clear_access_account.json',
      method: 'put'
    })
  },
  users_list: () => {
    return Api.request({
      url: '/admins/users_list.json',
      method: 'get'
    })
  }
}


export default adminsPathTo
